import { Avatar, Badge, Skeleton } from '@dreamtree-org/twreact-ui';
import { CheckCircle2, MapPin, Star } from 'lucide-react';
import { useQuery } from '@/lib/useQuery';
import { SectionCard } from '@/components';
import { useStorefront } from '../StorefrontContext';

/** Visible seller business identity (C-02): legal name, GSTIN, address, verifications. */
export default function SellerCard({ query }) {
  const sf = useStorefront();
  const own = useQuery('sfSeller', { slug: sf.seller.slug, name: sf.seller.name }, { select: (r) => r.data, enabled: !query });
  const q = query || own;
  const s = q.data;
  return (
    <SectionCard title="Sold by">
      {!s ? (
        q.error ? <p className="text-sm opacity-70">Seller details are unavailable right now.</p> : <Skeleton count={4} />
      ) : (
        <div className="space-y-3 text-sm">
          <div className="flex items-center gap-3">
            <Avatar name={s.name} size="md" />
            <div className="min-w-0">
              <div className="font-semibold">{s.name}</div>
              <div className="flex flex-wrap items-center gap-x-2 text-xs opacity-80">
                {s.rating != null ? <span className="inline-flex items-center gap-1"><Star className="h-3.5 w-3.5 text-warning-500" aria-hidden="true" />{s.rating} ({s.reviews} reviews)</span> : null}
                {s.since_year ? <span>Selling here since {s.since_year}</span> : null}
              </div>
            </div>
            {s.verifications.length ? <span className="ml-auto"><Badge size="xs" variant="success">Verified</Badge></span> : null}
          </div>
          <ul className="space-y-1.5">
            {s.verifications.map((v) => (
              <li key={v.key} className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-success-600" aria-hidden="true" />{v.label}</li>
            ))}
          </ul>
          <div className="space-y-1 border-t border-[var(--app-border)] pt-2 text-xs opacity-80">
            <div className="flex gap-1.5"><MapPin className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />{s.address || s.city}</div>
            <div>{s.legal_name}{s.gstin ? ` · GSTIN ${s.gstin}` : ''}</div>
            <div>{s.units_sold ? `${s.units_sold} order${s.units_sold === 1 ? '' : 's'} delivered · ` : ''}{s.support.hours ? `Support ${s.support.hours}` : ''}{s.support.phone ? ` · ${s.support.phone}` : ''}</div>
          </div>
        </div>
      )}
    </SectionCard>
  );
}
